<template>
  <div>
    <b-card no-body>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="search-section"
        >
          <div
            v-if="!isLoading"
            class="p-4"
          >
            <search-global
              state="banner/getBannerListV2"
              :filter="{ active: true }"
              :selected="list2"
              hide-selected
            >
              <template #item="{ data, loading }">
                <draggable
                  :list="data"
                  tag="ul"
                  group="people"
                  class="list-group list-group-flush cursor-move"
                  v-bind="dragOptions"
                  :disabled="(list2.length === limit && dragRight === false) || loading"
                  @start="dragLeft = true"
                  @end="dragLeft = false"
                >
                  <transition-group
                    type="transition"
                    :name="!drag ? 'flip-list' : null"
                    class="drop-area"
                  >
                    <div
                      v-for="(item, index) in data"
                      :key="`list-item-${index}`"
                    >
                      <banner-item
                        :data="item"
                        class="mb-50 item-content"
                      />
                    </div>
                  </transition-group>
                </draggable>
              </template>
            </search-global>
          </div>

          <div
            v-else
            class="mt-4"
          >
            <b-skeleton width="85%" />
            <b-skeleton width="55%" />
            <b-skeleton width="70%" />
          </div>
        </b-col>
        <!-- Merchant -->
        <b-col
          cols="12"
          md="6"
          class="result-section"
        >
          <div class="p-4">
            <div class="header-result">
              <b-row align-v="center">
                <b-col>
                  <h5>Banner Terpilih ({{ list2.length }})</h5>
                </b-col>
                <b-col cols="auto">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    :disabled="!list2.length || isSubmiting"
                    @click="onSubmit"
                  >
                    <b-spinner
                      v-if="isSubmiting"
                      small
                    />
                    Simpan
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <hr>

            <div v-if="!isLoading">
              <b-alert
                :show="list2.length === limit"
                variant="warning"
              >
                <div class="alert-body">
                  <feather-icon
                    class="mr-25"
                    icon="InfoIcon"
                  />
                  <span class="ml-25">Anda hanya dapat memilih maksimal {{ limit }} item</span>
                </div>
              </b-alert>

              <div>
                <draggable
                  :list="list2"
                  tag="ul"
                  group="people"
                  class="list-group list-group-flush cursor-move"
                  v-bind="dragOptions"
                  @start="dragRight = true"
                  @end="dragRight = false"
                >
                  <transition-group
                    type="transition"
                    :name="!drag ? 'flip-list' : null"
                    class="drop-area"
                    :class="{ 'is-empty': !list2.length, 'is-drag-wait': dragLeft }"
                  >
                    <div
                      v-for="(item, index) in list2"
                      :key="`list-item-${index}`"
                      class="position-relative"
                    >
                      <b-badge
                        variant="light-info"
                        class="position-absolute z-index-2 r-0 badge-number"
                      >
                        {{ index + 1 }}
                      </b-badge>
                      <banner-item
                        :data="item"
                        class="mb-50 item-content"
                      />
                    </div>
                  </transition-group>
                </draggable>
              </div>
            </div>

            <div
              v-else
              class="mt-4"
            >
              <b-skeleton width="85%" />
              <b-skeleton width="55%" />
              <b-skeleton width="70%" />
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BBadge,
  BAlert,
  BSkeleton,
  BSpinner,
} from 'bootstrap-vue'

// Vee Validate
import { mapActions } from 'vuex'
import SearchGlobal from '@/layouts/components/custom/SearchGlobal.vue'
import BannerItem from '@/layouts/components/custom/BannerItem.vue'
import Ripple from 'vue-ripple-directive'
import draggable from 'vuedraggable'

export default {
  name: 'ProductInfoForm',
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BBadge,
    BAlert,
    BSpinner,
    BSkeleton,
    draggable,
    BannerItem,
    SearchGlobal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      list2: [],
      limit: 10,
      isSubmit: false,
      isSubmiting: false,
      isDrag: false,
      drag: false,
      dragRight: false,
      dragLeft: false,
      isLoading: false,
      orderedData: [],
    }
  },
  computed: {
    order() {
      if (this.list2.length) return this.list2.map(el => el.id)
      return []
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        ghostClass: 'ghost',
        setData: this.modifyDragItem,
      }
    },
  },
  created() {
    this.loadBannerOrdered()
  },
  methods: {
    ...mapActions('banner', ['orderBannerV2', 'getBannerListV2']),
    async onSubmit() {
      this.isSubmiting = true
      await this.orderBannerV2({ order: this.order })
      this.isSubmiting = false
    },
    async loadBannerOrdered() {
      this.isLoading = true
      const response = await this.getBannerListV2({ order: true })

      if (response) {
        this.list2 = response.data
      }

      this.isLoading = false
    },
    tesDrag() {
    },
    modifyDragItem(dataTransfer) {
      const img = new Image()
      img.src = ''
      dataTransfer.setDragImage(img, 0, 0)
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss" scoped>
::v-deep .vs__actions {
    .vs__clear {
        visibility: hidden;
    }
}

.search-section {
    background-color: #f8f8f8;
}

.result-section {
    align-self: start;
    position: -webkit-sticky;
    position: sticky;
    top: 50px;
    z-index: 11;
}

.header-result {
  position: sticky;
  width: 100%;
  top: 100px;
  z-index: 11;
  background-color: #fff;
  -webkit-box-shadow: 0px 0px 31px 14px rgba(255,255,255,1);
  -moz-box-shadow: 0px 0px 31px 14px rgba(255,255,255,1);
  box-shadow: 0px 0px 31px 14px rgba(255,255,255,1);
}

.dark-layout {
  .header-result {
    background-color: #283046;
    -webkit-box-shadow: 0px 0px 31px 14px rgba(40,48,70,1);
    -moz-box-shadow: 0px 0px 31px 14px rgba(40,48,70,1);
    box-shadow: 0px 0px 31px 14px rgba(40,48,70,1);
  }

  .search-section {
    background-color: #384056;
  }
}

.badge-number {
    opacity: 1 !important;
    transition: 0.5s all;
}

.is-drag .badge-number {
    opacity: 0 !important;
}

.is-drag .item-content {
    border-color: #7367f0 !important;
    background: rgba(115,103,240,.12);
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost .item-content {
    border-color: #7367f0 !important;
    background: rgba(115,103,240,.12);
}
.list-group {
  min-height: 300px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.drop-area {
    min-height: 300px;
    transition: 0.2s all ease;

    &.is-empty {
        background: rgba(114, 103, 240, 0.059);
        border-radius: 8px;
        position: relative;

        &::before {
            content: "Tarik dan letakkan di sini!";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    &.is-drag-wait {
      border: 1px solid #7367f0;
      border-radius: 8px;
      border-style: dashed;
      padding: 0.25rem;
      transition: 0.2s all ease;
    }
}
</style>
